module.exports = __webpack_public_path__ + "media/images/plans/photo_location/main1-7ee78efbcb5cd139303dad8a476b72a4.png";